/**
 * Mixin for resource wrappers
 */
import { eventBus } from "@/event-bus";
import { mapActions } from "vuex";
import { goBack } from "@/utility/goBack";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    needModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openModal: false,
      currentRoute: this.$route,
      redirectRouteName: "",
      redirectRouteParams: {},
      logoutActive: false,
    };
  },
  mounted() {
    window.addEventListener("beforeunload", this.beforeUnloadAction);

    eventBus.$on("open-exit-modal", (data, logout) => {
      this.redirectRouteName = data;
      this.popstateEventAction(undefined, logout);
    });
    window.addEventListener("popstate", this.popstateEventAction);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnloadAction);
    window.removeEventListener("popstate", this.popstateEventAction);
    this.removePopstateEventAction();
    eventBus.$off("open-exit-modal");
  },
  watch: {
    needModal: function (newVal) {
      if (newVal === true) {
        this.currentRoute.meta.disableRedirect = true;
      } else {
        this.currentRoute.meta.disableRedirect = false;
      }
    },
  },
  methods: {
    ...mapActions({
      logout: "auth/logout",
    }),
    beforeUnloadAction(event) {
      if (this.needModal) {
        event.returnValue = true;
      }
    },
    popstateEventAction(_, logout) {
      if (this.needModal) {
        this.openModal = true;
        if (logout) {
          this.logoutActive = true;
        }
      } else if (logout) {
        this.logout();
      }
    },
    removePopstateEventAction() {
      window.removeEventListener("popstate", this.popstateEventAction);
    },
    leavePage() {
      this.currentRoute.meta.disableRedirect = false;

      this.removePopstateEventAction();

      if (this.logoutActive) {
        this.logout();

        return;
      }

      if (this.redirectRouteName) {
        if (this.redirectRouteParams) {
          this.$router.push({ name: this.redirectRouteName, params: this.redirectRouteParams });
        } else {
          this.$router.push({ name: this.redirectRouteName });
        }
      } else {
        goBack(this.$router);
      }
    },
    cancelLeavePage() {
      this.redirectRouteName = "";
      this.redirectRouteParams = {};
      this.logoutActive = false;
    },
    cancelButtonHandler() {
      if (this.needModal) {
        this.openModal = true;
      } else {
        goBack(this.$router);
      }
    },
    saveButtonHandler() {
      this.currentRoute.meta.disableRedirect = false;
      this.$emit("saveAction");
    },
  },
};
